module.exports = __webpack_public_path__ + "img/bolivia.feb8b3df.svg";